import { DateTableCell, PriceTableCell } from '@/components/shared/Table';
import { TokenSymbol } from '@/types/tokens';
import { ChakraComponent, Flex, IconProps, Td, Tr } from '@chakra-ui/react';
import { TableRowMediaItem, TableRowMediaItemProps } from '@sphere/ui';
import { rem } from 'polished';
import { PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
  mediaItemProps: TableRowMediaItemProps;
  icon: {
    Component: ChakraComponent<'svg', IconProps>;
    label: string;
  };
  currency: TokenSymbol;
  startTime: string;
  endTime?: string;
  tokenAmount?: number;
  usdAmount?: number;
}

export const AccountTableItemDesktop = ({
  mediaItemProps,
  icon,
  currency,
  startTime,
  endTime,
  tokenAmount,
  usdAmount,
  children,
}: Props) => (
  <Tr>
    <Td px="space.16">
      <TableRowMediaItem {...mediaItemProps} />
    </Td>
    <Td>
      <Flex align="center" gap="space.8">
        <icon.Component boxSize={rem(20)} />
        {icon.label}
      </Flex>
    </Td>
    <PriceTableCell amount={tokenAmount} currency={currency} usdPrice={usdAmount} align="right" />
    <DateTableCell date={startTime} includeSeconds />
    {endTime ? <DateTableCell date={endTime} includeSeconds /> : <Td />}
    {children}
  </Tr>
);
